var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsIntelligence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.708,
    height: 32.708,
    viewBox: "0 0 32.708 32.708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil_1_",
    "data-name": "pencil (1)",
    transform: "translate(0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_52744",
    "data-name": "Path 52744",
    d: "M26,19.294a6.7,6.7,0,0,0-1.6.194L13.221,8.31A6.708,6.708,0,0,0,4.352.428.958.958,0,0,0,4.012,2L5.94,3.931,5.673,5.674l-1.743.267L2,4.013a.958.958,0,0,0-1.575.34,6.709,6.709,0,0,0,7.882,8.869L19.486,24.4a6.708,6.708,0,0,0,8.869,7.882.958.958,0,0,0,.34-1.574l-1.929-1.928.267-1.743,1.744-.267L30.706,28.7a.958.958,0,0,0,1.574-.34A6.707,6.707,0,0,0,26,19.294M29.716,7.9l2.711-2.711a.958.958,0,0,0,0-1.355L28.87.282a.958.958,0,0,0-1.355,0L24.8,2.992ZM2.574,25.652l-2.5,5.715a.958.958,0,0,0,1.262,1.262l5.715-2.5Z",
    transform: "translate(0)",
    fill: "#3db6fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52745",
    "data-name": "Path 52745",
    d: "M72.1,73.809l5.739-5.739,4.912,4.912-5.739,5.739ZM58.11,87.8l6.371-6.371,4.912,4.912-6.371,6.371Z",
    transform: "translate(-54.398 -63.721)",
    fill: "#3db6fb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsIntelligence);
export default __webpack_public_path__ + "static/media/Skills Intelligence.6665f991da49785a6c1de824aba0cd2f.svg";
export { ForwardRef as ReactComponent };